module.exports = __webpack_public_path__ + "img/title-@3x.19c02682.png";